import { Box, MenuItem, TextField, Stack } from '@mui/material';
import React, { useRef } from 'react';
import { auditEntity, handleValidateCodevalue } from '../../../Utility/constant';
import { useSelector } from 'react-redux';
import './audit.css';

const AuditSearch = ({ requiredError, auditvalue, handleChangeSearchField }) => {

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const inputSearchRef = useRef();

    return (
        <React.Fragment>
            <Box className="audit-search-fields">
                <Stack direction="row" spacing={2} alignItems="center" className="audit-search-row">
                    <TextField
                        id="entity"
                        select
                        name="entity"
                        label={handleValidateCodevalue(internationalise, "AUDI_SEARCH_ENTITY")}
                        value={auditvalue?.entity ? auditvalue?.entity : ""}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChangeSearchField}
                        error={auditvalue?.entity ? false : requiredError?.entity}
                    >
                        {auditEntity?.map((option) => (
                            <MenuItem key={option?.id} value={option?.name}>
                                {handleValidateCodevalue(internationalise, option?.name)}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        id="entityId"
                        type='number'
                        label={handleValidateCodevalue(internationalise, "AUDI_SEARCH_REF_ID")}
                        name="entityId"
                        inputRef={inputSearchRef}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChangeSearchField}
                        value={auditvalue?.entityId ?? ''}
                        error={auditvalue?.entityId ? false : requiredError?.entityId}
                    />
                </Stack>
            </Box>
        </React.Fragment>
    );
};

export default AuditSearch;